/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type Login = {
  /**
   * User email address
   */
  username: string;
  /**
   * User password
   */
  password: string;
  /**
   * OAuth2 grant type
   */
  grant_type?: Login.grant_type;
  /**
   * OAuth2 scope
   */
  scope?: string;
};
export namespace Login {
  /**
   * OAuth2 grant type
   */
  export enum grant_type {
    PASSWORD = 'password',
    CLIENT_CREDENTIALS = 'client_credentials',
    REFRESH_TOKEN = 'refresh_token',
  }
}
